import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import DesktopHomePage from './pages/DesktopHomePage'
import EditorPage from './pages/EditorPage'
import AlphaPage from './pages/AlphaPage'
import { useExtensionBridge } from './hooks/useExtensionBridge'

declare const __ELECTRON__: boolean | undefined
const isElectron = typeof __ELECTRON__ !== 'undefined' && (__ELECTRON__ as any) === true

function App() {
    useExtensionBridge()
    if (isElectron) document.body.classList.add('electron-desktop')

    return (
        <Routes>
            <Route path="/" element={isElectron ? <DesktopHomePage /> : <HomePage />} />
            <Route path="/editor" element={<EditorPage />} />
            <Route path="/editor/:projectId" element={<EditorPage />} />
            <Route path="/demo" element={<EditorPage isDemo={true} />} />
            <Route path="/alpha" element={<AlphaPage />} />
        </Routes>
    )
}

export default App
